import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../function/helper";

export default function PayLinkAgentOrdersPayButton({
  item,
  onSubmit,
  disabled,
  onPending,
}) {
  const { isPending, mutate } = useMutation({
    mutationKey: ["PayLinkAgentOrdersPayButton"],
    mutationFn: () =>
      postRequestByAuth("/totalpost/v1/payLink/agent/pay", {
        numberParcel: item.numberParcel,
      }).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res.data.message,
            confirmButtonText: "متوجه شدم",
          });
          onSubmit();
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        });
      }),
  });

  const submit = () => {
    Swal.fire({
      icon: "warning",
      text: "آیا از پرداخت سفارش، توسط خودتان مطمئنید؟ توجه داشته باشید مبلغ از کیف پول شما کسر می‌شود.",
      confirmButtonText: "مطمئنم",
      confirmButtonColor: "blue",
      showCancelButton: true,
      cancelButtonColor: "red",
      cancelButtonText: "خیر",
    }).then(res => {
      if (res.isConfirmed) {
        onPending();
        mutate();
      }
    });
  };

  return (
    <LoadingButton
      center
      className="btn-outline-purple text-center"
      isLoading={isPending}
      title={isPending ? "در حال پرداخت" : "پرداخت از کیف پول خودم"}
      type="button"
      onClick={submit}
      disabled={disabled}
    />
  );
}
